function Pause(props) {
  function restart() {
    props.restart();
  }

  return (
    <div className={props.pause ? "pause" : "off"}>
      <div className="pause-card">
        <button className="pause-restart pause-card-button" onClick={restart}>
          Restart
        </button>
        <button className="pause-card-button" onClick={props.newGame}>
          New Game
        </button>
        <button className="pause-card-button" onClick={props.changePause}>
          Resume Game
        </button>
      </div>
    </div>
  );
}

export default Pause;
